import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface BalanceRefreshContextType {
  refreshKey: number;
  triggerRefresh: () => void;
}

const BalanceRefreshContext = createContext<BalanceRefreshContextType | undefined>(undefined);

export const useBalanceRefresh = () => {
  const context = useContext(BalanceRefreshContext);
  if (context === undefined) {
    throw new Error('useBalanceRefresh must be used within a BalanceRefreshProvider');
  }
  return context;
};

interface BalanceRefreshProviderProps {
  children: ReactNode;
}

export const BalanceRefreshProvider: React.FC<BalanceRefreshProviderProps> = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
    console.log('🔄 [BalanceRefreshContext] Balance refresh triggered, new key:', refreshKey + 1);
  }, [refreshKey]);

  const value: BalanceRefreshContextType = {
    refreshKey,
    triggerRefresh
  };

  return (
    <BalanceRefreshContext.Provider value={value}>
      {children}
    </BalanceRefreshContext.Provider>
  );
};